<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;">
      <a-form-item>
        <a-radio-group v-model="platform" button-style="solid" @change="init_data">
          <a-radio-button value="">
            ALL
          </a-radio-button>
          <a-radio-button value="ios">
            <a-icon type="apple" />
          </a-radio-button>
          <a-radio-button value="android">
            <a-icon type="android" />
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-input v-model="name" allowClear placeholder="产品/应用名称" @pressEnter="init_data">
          <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button icon="sync" @click="refresh()"></a-button>
      </a-form-item>
    </a-form>
    <a-spin :spinning="dataLoad" :tip="tipLoad" style="flex: 1;overflow-y: scroll;overflow-x: hidden">
      <a-row :gutter="16" >
        <a-col :span="6"
               :key="dataIndex"
               v-for="(dataItem,dataIndex) in dataList"
               style="margin-bottom: 16px;">
          <a-card hoverable :body-style="{padding:'15px'}">
            <!--<img-->
            <!--  slot="cover"-->
            <!--  alt="example"-->
            <!--  src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"-->
            <!--/>-->
            <!--<template slot="actions" class="ant-card-actions">-->
            <!--  <a-icon key="setting" type="setting" />-->
            <!--  <a-icon key="edit" type="edit" />-->
            <!--  <a-icon key="ellipsis" type="ellipsis" />-->
            <!--</template>-->
            <a-card-meta>
              <a-avatar
                slot="avatar"
                :src="dataItem.icon"
              />
              <template slot="title" >
                <span @click="_copy_text(dataItem.product_name)">{{dataItem.product_name}}</span>
              </template>
              <template slot="description">
                <div style="display: flex;justify-content: space-between;margin-bottom: 5px;">
                  <span style="color: #1890ff" @click="_copy_text(dataItem.package_name)">{{dataItem.package_name}}</span>
                  <span v-if="dataItem.platform==='ios'" style="color: #cf1322" @click="_copy_text(dataItem.app_store_id)">{{dataItem.app_store_id}}</span>
                </div>
                <div style="display: flex;justify-content: space-between">
                  <span style="color: #3f8600" @click="_copy_text(dataItem.app_id)">GB_ID : {{dataItem.app_id}}</span>
                  <a-icon style="font-size: 24px;" :type="dataItem.platform==='ios'?'apple':'android'" />
                </div>
              </template>
            </a-card-meta>
          </a-card>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import {GetAppList, RefreshAppList} from "@/api/v1/app_api";

export default {
  name: "App",
  data(){
    return {
      platform:'',
      name:'',
      dataList:[],
      dataLoad:false,
      tipLoad:'',
    }
  },
  mounted() {
    this.init_data()
  },
  computed:{},
  methods:{
    init_data(){
      if (this.dataLoad) return
      this.dataLoad = true
      this.tipLoad = "数据加载中"
      GetAppList({platform:this.platform,name:this.name}).then(resp => {
        this.dataLoad = false
        if (resp.code===200){
          this.dataList = resp.data
        }
      })
    },
    refresh(){
      if (this.dataLoad) return
      this.dataLoad = true
      this.tipLoad = "数据更新中"
      RefreshAppList({}).then(resp => {
        this.dataLoad = false
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.init_data()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/System/Application/App.vue